import React, { useRef } from 'react';
import './button.css';
import { gsap, prefersReducedMotion } from '../hooks/useGsapAnimations';

const Button = (props) => {
  const buttonRef = useRef(null);

  const animateButton = (vars) => {
    if (!buttonRef.current || prefersReducedMotion()) return;

    gsap.to(buttonRef.current, {
      ...vars,
      duration: vars.duration || 0.22,
      ease: vars.ease || 'power2.out',
      overwrite: 'auto',
    });
  };

  return (
    <button
      className={props.className}
      disabled={props.disabled}
      aria-label={props['aria-label']}
      onClick={props.onClick}
      onMouseEnter={() => animateButton({ y: -3, scale: 1.04 })}
      onMouseLeave={() => animateButton({ y: 0, scale: 1 })}
      onPointerDown={() => animateButton({ scale: 0.94, duration: 0.12 })}
      onPointerUp={() => animateButton({ y: -3, scale: 1.04 })}
      onPointerLeave={() => animateButton({ y: 0, scale: 1 })}
      ref={buttonRef}
      type={props.type || 'button'}
    >

      {props.text}

      {props.img && (
        <img src={props.img} alt="" />
      )}

    </button>
  );
}
 
export default Button;
